import { usePassportProvider } from "@/context";
import { useQuest } from "@/context/QuestProvider";
import { updateQuestWithAutoHide } from "@/context/QuestProvider/questActionHandlers";
import type { QuestState } from "@ui-kit/QuestList";
import {
  type Dispatch,
  type MutableRefObject,
  type SetStateAction,
  useCallback,
} from "react";
import { useGetWalletLatestEarnings } from "../api";
export const useCompleteQuest = (
  revalidateGemsAmount: () => void,
  setSelectedQuest: Dispatch<SetStateAction<QuestState | undefined>>,
  asyncCompleteHandler: MutableRefObject<(() => Promise<unknown>) | undefined>,
) => {
  const { dispatchAction } = useQuest((store) => store);
  const { walletAddress } = usePassportProvider();
  const { mutate: mutateGetEarnings } =
    useGetWalletLatestEarnings(walletAddress);

  const completeQuest = useCallback(
    async (quest: QuestState) => {
      setSelectedQuest(undefined);
      if (asyncCompleteHandler.current) {
        await asyncCompleteHandler.current?.();
        asyncCompleteHandler.current = undefined;
      }

      await updateQuestWithAutoHide(dispatchAction, {
        ...quest,
        locked: false,
        completed: true,
        status: "completed",
      });

      revalidateGemsAmount();
      mutateGetEarnings();
    },
    [
      dispatchAction,
      revalidateGemsAmount,
      mutateGetEarnings,
      setSelectedQuest,
      asyncCompleteHandler,
    ],
  );

  return { completeQuest };
};
